import { Uppy } from '@lyearn/shared/hooks/useUppy';
import { JobEntityStatusEnum, JobPurposeEnum } from '@/types/schema';

import {
  GetUpdateDialogDescriptionType,
  GetUpdateItemsType,
} from './components/UpdateDataDialog/types';
import { JobStateFragment } from './graphql/fragments/generated/JobState';
import { ImportJobType } from './hooks/useImportProps/types';

export enum BulkImportFileTypes {
  CSV = 'csv',
  XLSX = 'xlsx',
}

export interface BulkImportProps {
  size?: 'small' | 'large';
  className?: string;
  jobPurpose: JobPurposeEnum[];
  fileInputRef: React.RefObject<HTMLInputElement>;
  uppy: Uppy | null;
  currentImportJob?: ImportJobType;
  onImportStatusUpdate: (status: JobEntityStatusEnum) => void;
  updateDataDialogProps: {
    getDescription?: GetUpdateDialogDescriptionType;
    getUpdateItems?: GetUpdateItemsType;
  };
  failedSnackbarMessage: string;
  refetchJobs: (...args: any[]) => void;
  onComplete?: (job: JobStateFragment) => void;
  onClose?: VoidFunction;
  preventRefetch?: boolean;
  fileType?: BulkImportFileTypes;
  hideShowDetailsButton?: boolean;
  referenceId?: string;
}

export type ConfigType = {
  Icon: React.ReactNode;
  descriptionKey: string;
  progress: number;
  rightNode?: React.ReactNode;
};
